import React from 'react'
import { Redirect } from 'react-router'

import { RoutePaths } from './RoutePaths'

export const RedirectToLogin: React.FC = () => <Redirect to={RoutePaths.Home} />
